import gql from "graphql-tag";

export default gql`
  mutation CreateContract($contractInput: ContractInputInput, $customerId: ID) {
    createContract(contractInput: $contractInput, customerId: $customerId) {
      id
    }
  }
`;
